export enum Role {
    ADMIN = 'ADMIN',
    CLIENT = 'CLIENT'
}
